import { TableSummaryRow } from "@devexpress/dx-react-grid";
import { Text } from 'components/Typography';

export const GroupSummaryItemComponent = (data: TableSummaryRow.ItemProps) => {
    return (
        <Text fontSize="m" fontWeight="bold">
            Messages: {data.value}
        </Text>
    );
};